import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CaError, CaFormFieldComponent, CaLabel } from '@global-front-components/ui/form-field';
import { TranslateModule } from '@ngx-translate/core';
import { CaDatepickerComponent } from '@global-front-components/ui/datepicker';
import { CaSelectComponent } from '@global-front-components/ui/select';
import { PreguntaCatalogo, RespuestaCatalogo } from '../../../comun/model/catalogo.model';
import { Pregunta } from '../../../comun/model/poliza.model';

@Component({
	selector: 'app-datos-conductor',
	standalone: true,
	imports: [
		CommonModule,
		CaLabel,
		CaError,
		CaFormFieldComponent,
		TranslateModule,
		CaDatepickerComponent,
		ReactiveFormsModule,
		CaSelectComponent],
	templateUrl: './datos-conductor.component.html',
	styleUrls: ['./datos-conductor.component.scss']
})
export class DatosConductorComponent implements OnInit{
	@Input() form: FormGroup;
	@Input() preguntasCatalogo: PreguntaCatalogo[];
	@Input() preguntasPoliza: Pregunta[] = [];
	
	nacionalidades: RespuestaCatalogo[];
	private readonly valorNacionalidadEspana = '066';

	constructor(private fb: FormBuilder){}

	ngOnInit(): void {
		this.buildForm();
		this.extraerInfoCatalogo();
	}

	buildForm(): void {
	const fechaNacimientoISO = this.preguntasPoliza?.find(p => p.idPregunta === 2148)?.respuesta;
	const fechaNacimiento = fechaNacimientoISO ? new Date(String(fechaNacimientoISO)).getTime() : '';
	this.form.addControl('preg_2148', this.fb.control(fechaNacimiento, [Validators.required]));

	const fechaCarnetISO = this.preguntasPoliza?.find(p => p.idPregunta === 2149)?.respuesta;
	const fechaCarnet = fechaCarnetISO ? new Date(String(fechaCarnetISO)).getTime() : '';
	this.form.addControl('preg_2149', this.fb.control(fechaCarnet, [Validators.required]));

	const nacionalidad = this.preguntasPoliza?.find(p => p.idPregunta === 2085)?.respuesta || this.valorNacionalidadEspana;
	this.form.addControl('preg_2085', this.fb.control(nacionalidad, [Validators.required]));
	}


	extraerInfoCatalogo(): void {
		if (!this.preguntasCatalogo) {
			return;
		}
		const preguntaNacionalidades = this.preguntasCatalogo?.find(p => p.idPregunta === 2085);
		this.nacionalidades = preguntaNacionalidades?.respuestas;
	}
}
